import { render, staticRenderFns } from "./uploadSource.vue?vue&type=template&id=28c3be7d&scoped=true&"
import script from "./uploadSource.vue?vue&type=script&lang=js&"
export * from "./uploadSource.vue?vue&type=script&lang=js&"
import style0 from "./uploadSource.vue?vue&type=style&index=0&id=28c3be7d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c3be7d",
  null
  
)

export default component.exports